//import vue from 'vue'
//import vuex from 'vuex'

Vue.use(Vuex)
const state = {
	router_tabs: [

	],
	router_names: [

	],

}
export default new Vuex.Store({
	state,
	mutations: {

		
		TO_ROUTER_TABS(state, to_from) {
			var to = to_from[0]
			var from = to_from[1]

			for(var i = 0; i < state.router_tabs.length; i++) {
				if(state.router_tabs[i].path == from.path) {
					state.router_tabs[i].is_show = false
				}
			}
			for(var i = 0; i < state.router_tabs.length; i++) {

				if(state.router_tabs[i].path == to.path) {
					state.router_tabs[i].is_show = true
					return
				}
			}
			state.router_tabs.push({
				path: to.path,
				name: to.meta.name,
				is_show: true,
				component_name: to.meta.component_name,
			})
			if(state.router_names.indexOf(to.meta.component_name) == -1) {
				state.router_names.push(to.meta.component_name)
			}

		},
		DELETE_ROUTER_TAB(state, tab_router) {
			var tab = tab_router[0]
			var router = tab_router[1]

			for(var i = 0; i < state.router_tabs.length; i++) {
				if(state.router_tabs[i].path == tab.path) {
					//如果被删除的路由非正在显示的，那么就不改变路由
					if(tab.is_show == false) {
						state.router_tabs.splice(i, 1)
						i--
						
					} else {
						//删除的是正在显示的
						if(i == 0) {
							//删第0个的话，删除后，跳到后一个
							var next = state.router_tabs[i + 1]
							state.router_tabs.splice(i, 1)
							i--
							router.push(next.path)
							
						} else {
							//不是删第0个的话，删除后，跳到前一个
							var pre = state.router_tabs[i - 1]
							state.router_tabs.splice(i, 1)
							i--
							router.push(pre.path)
							

						}
					}

					if(state.router_names.indexOf(tab.component_name) != -1) {
						state.router_names.splice(state.router_names.indexOf(tab.component_name), 1)
					}

					break

				}
			}

		},

	},
	
})